"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@bimser/core");
const actionTypes_1 = require("../actionTypes");
const ILoad_1 = require("../entities/payloads/ILoad");
function loadObjectExplorer(data) {
    const action = (0, core_1.createSyncAction)(actionTypes_1.LOAD, (0, ILoad_1.LoadPayloadFactoryFromJS)(data));
    return action;
}
exports.default = loadObjectExplorer;
//# sourceMappingURL=load.js.map